//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const userService = {
  me,
  doGet,
  doSave,
  getCurrentUser,
  findByFiltro,
  getExtension,
  doDelete,
  esqueciSenha,
  updateRecoverPassword,
  isCurrent,
  updatePassword,
  testAdminAccess,
  testAprovadorAccess,
  testPAAccess,
};

function findByFiltro(options: Options, filter: any): Promise<any> {
  const params = [];
  if (_.get(filter, 'nome')) {
    params.push(`nome=${encodeURIComponent(filter.nome)}`);
  }
  if (_.get(filter, 'cpf')) {
    params.push(`cpf=${encodeURIComponent(filter.cpf)}`);
  }
  if (_.get(filter, 'cliente.codigoCliente')) {
    params.push(
      `codigoClienteParam=${encodeURIComponent(filter.cliente.codigoCliente)}`
    );
  }
  if (_.get(options, 'page') !== undefined) {
    params.push(`page=${options.page - 1}`);
  }
  const queryString = params.length ? `?${params.join('&')}` : '';
  return defaultService.doGet(
    `${urlsConstants.USUARIO}filtro${queryString}`,
    options
  );
}

function doDelete(id) {
  return defaultService.doDelete(`${urlsConstants.USUARIO}${id}`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.USUARIO}${id}`);
}

function doSave(usuario) {
  return defaultService.doSave(urlsConstants.USUARIO, usuario);
}

function me() {
  return defaultService.doGet(urlsConstants.USER_ME).then((response) => {
    if (response.data.error === 'invalid_token') {
      return Promise.reject('invalid_token');
    }
    localStorage.setItem('user', JSON.stringify(response.data));
    return response;
  });
}

function getCurrentUser() {
  let token = localStorage.getItem('user');
  if (!token) {
    return null;
  }
  let user = JSON.parse(token);
  return user;
}

function esqueciSenha(cpfSend) {
  return defaultService.doPost(
    `${urlsConstants.USER_PUBLIC}recoverPassword/`,
    cpfSend
  );
}

function updateRecoverPassword(values) {
  return defaultService.doPut(
    `${urlsConstants.USER_PUBLIC}updateRecoverPassword/`,
    values
  );
}
function updatePassword(values) {
  return defaultService.doPut(
    `${urlsConstants.USUARIO}updatePassword/`,
    values
  );
}

function getExtension() {
  let user = localStorage.getItem('user');
  if (!user) {
    return false;
  }
  user = JSON.parse(user);
  return _.get(user, 'role.extension');
}

function isCurrent(user) {
  let currentUser = getCurrentUser();
  if (currentUser.id === user.id) {
    return true;
  }
  return false;
}

function testAdminAccess() {
  return defaultService.doGet(`${urlsConstants.USUARIO}/admin-only`);
}

function testAprovadorAccess() {
  return defaultService.doGet(`${urlsConstants.USUARIO}/aprovador-only`);
}

function testPAAccess() {
  return defaultService.doGet(`${urlsConstants.USUARIO}/pa-only`);
}
